import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import {
  MaterialLayoutRenderer,
} from '@jsonforms/material-renderers';
import { Box } from '@mui/material';

/**
 * CustomLayoutRenderer2 - полностью повторяет поведение стандартного HorizontalLayoutRenderer
 * из @jsonforms/material-renderers с добавлением flex-wrap: nowrap
 * 
 * Исходный код: node_modules/@jsonforms/material-renderers/src/layouts/MaterialHorizontalLayout.tsx
 */
const CustomHorizontalLayoutRenderer = ({
  uischema,
  renderers,
  cells,
  schema,
  path,
  enabled,
  visible,
}) => {
  const layout = uischema;
  const childProps = {
    elements: layout.elements,
    schema,
    path,
    enabled,
    direction: 'row',
    visible,
  };

  const width = uischema.options?.width ? uischema.options.width : undefined

  return (
    <Box
      sx={{
        '& .MuiGrid-container': {
          flexWrap: 'nowrap',
        },
        width: width
      }}
    >
      <MaterialLayoutRenderer
        {...childProps}
        renderers={renderers}
        cells={cells}
      />
    </Box>
  );
};

export default withJsonFormsLayoutProps(CustomHorizontalLayoutRenderer);

